import { useEffect, useState } from 'react';
import { Typography, Button, Spin, Flex } from 'antd';
import { showNotificationTopEnd } from '../../util/utils';
import { callGetWebWinners } from '../../services/winnersService';
import NotFound from '../NotFound/NotFound';
import WinnerCard from './WinnerCard/WinnerCard';

import botargaTrofeo from '../../assets/images/botarga/Rifadito_Trofeo.png';
import botargaNervioso from '../../assets/images/botarga/Rifadito_Nervioso.png';
import botargaManosCadera from '../../assets/images/botarga/Rifadito_Manos_Cadera.png';

import './WinnersList.css';

const { Title } = Typography;

export default function WinnersListDos() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [firstLoad, setFirstLoad] = useState(true);
    const [isError, setIsError] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });


    useEffect(() => {
        getWinners((pagination.current === 1) ? pagination.current - 1 : pagination.current, pagination.pageSize);
        // eslint-disable-next-line
    }, []);


    const getWinners = async (page, size) => {
        setLoading(true);

        const response = await callGetWebWinners(page, size);
        if (response?.status === 200) {
            const newItems = response.data.content || [];

            // Acumular registros
            setData(prev => [...prev, ...newItems]);

            const totalElements = response?.data?.page?.totalElements;
            const totalPages = response?.data?.page?.totalPages;

            setPagination({
                current: page + 1,
                pageSize: size,
                total: totalElements,
            });

            setHasMore((page + 1) < totalPages);
            setIsError(false);
        } else {
            showNotificationTopEnd("error", "Error, por favor recarga la página");
            setIsError(true);
        }
        setFirstLoad(false);
        setLoading(false);
    };


    const handleLoadMore = () => {
        getWinners(pagination.current, pagination.pageSize);
    };


    return (
        <div className='complete-page'>
            <Flex className="winner-section-container">
                <Title className="winner-section-title" strong>
                    ¡Nuestros Ganadores!
                </Title>
            </Flex>
            {loading && firstLoad ? (
                <Spin spinning={loading} size="large">
                    <NotFound
                        title="Cargando..."
                        subtitle="Estamos cargando la información"
                        description="Espera unos momentos"
                        image={botargaManosCadera}
                    />
                </Spin>
            ) : (
                <>
                    {isError ? (
                        <NotFound
                            title="Oops! Parece que algo salió mal"
                            subtitle="Vuelve a intentarlo en otro momento"
                            description="Mantente informado a través de nuestras redes sociales"
                            image={botargaNervioso}
                        />
                    ) : (
                        <>
                            {data?.length === 0 ? (
                                <NotFound
                                    title="Aún no tenemos ganadores"
                                    subtitle="No te quedes atrás, ¡conviértete en nuestro primer ganador!"
                                    description="Sigue de cerca los sorteos en nuestras redes sociales"
                                    image={botargaTrofeo}
                                />
                            ) : (
                                <>
                                    <Flex style={{ flexWrap: 'wrap' }}>
                                        {data?.length > 0 && data.map((item, index) => (
                                            <WinnerCard key={index} item={item} index={index} />
                                        ))}
                                    </Flex>
                                    <div style={{ textAlign: "center", marginTop: 16 }}>
                                        {hasMore ? (
                                            <Button type="primary" onClick={handleLoadMore} className="load-more-button" size="large" loading={loading}>
                                                {loading ? "Cargando..." : "Cargar más"}
                                            </Button>
                                        ) : (
                                            <p style={{ marginBottom: 0, paddingBottom: 20 }}>No hay más elementos</p>
                                        )}
                                    </div>
                                </>)}
                        </>)}
                </>)}
        </div >
    );
};